import { IInsurance } from './InsuranceModel'
import { BuyersConsolidationQuoteServicesJSON } from './QuoteRequest/BuyersConsolidationQuoteServicesJSON'

export enum CarbonOffsetStrategy {
  All = 'all',
  None = 'none',
}

export interface CarbonOffsetService {
  offsetStrategy: CarbonOffsetStrategy
}

type TCustomsType = 'standard' | 'fiscal' | 't1' | 't2' | 't1_only' | 't2_only'
type TCustomsBondType = 'single' | 'annual' | 'own'
type Inspection = 'preShipment' | 'openPackage'
export interface IQuoteServices {
  customsSelected: boolean
  customsTypes: TCustomsType[]
  customsIssuance: boolean
  customsBondType?: TCustomsBondType
  customsHideFak?: boolean
  dangerousGoods: boolean
  dangerousGoodsAdditionalDetails?: string
  defermentAccountExists?: boolean
  hsCodesCount: number
  inspections?: Inspection[]
  insurances: IInsurance[]
  isStackable?: boolean
  specialEquipment?: boolean
  vatNumbers?: string[]
  vgm?: boolean
  buyersConsolidation?: BuyersConsolidationQuoteServicesJSON
  carbonOffset?: CarbonOffsetService
}
